import React from 'react';

const View = React.forwardRef(({children, ...props}: any, ref) => {
  return (
    <div {...props} ref={ref}>
      {children}
    </div>
  );
});

View.displayName = 'View';

export default View;
